import React, { useState, useRef, useEffect } from 'react';
import { Http } from '../utils';
import { useLocation } from 'react-router-dom';

const HomePage = () => {
  const [autStuta, setAutStuta] = useState(0)
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tokenName = searchParams.get('tokenName');
  const tokenValue = searchParams.get('tokenValue');
  const tenantId = searchParams.get('tenantId');
  const authCode = searchParams.get('auth_code');
  let obg = {tokenName, tokenValue, tenantId}
  if (tokenName) {
    localStorage.setItem('tenant-user', JSON.stringify(obg))
  }
  
  console.log('tokenName', tokenName)
  console.log("tokenValue", tokenValue)
  console.log("tenantId", tenantId)
  let href = window.location?.origin
  console.log('href')
  useEffect(()=>{
    if (tokenName) {
      Http.post('/admin/wxopen/auth/get_mobile_pre_auth_url', {params: {redirectUri: href}}).then(res=>{
        window.location.href = res;
      })
    }
    // 授权回调
    if (authCode) {
      Http.post('/admin/wxopen/auth/bind', {params: {authCode}}).then(res=>{
        setAutStuta(1)
      }).catch(err=>{
        setAutStuta(2)
      })
    }
  }, [])
  
  
  
  
  return (
    <div>
      {autStuta===1?<div>授权成功</div>:autStuta===2?<div>授权失败</div>:<div>待授权</div>}
    </div>
  );
};

export default HomePage;